/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { Logout } from '@mui/icons-material';
import StyledDrawerMenuLogoutContainer from 'common/theme/drawer-menu/StyledDrawerMenuLogoutContainer';
import StyledLogoutButton from 'common/theme/button/StyledLogoutButton';
import SidebarPanelContext from 'context/SidebarPanelContext';

function DrawerLogoutButton({ onClick }) {
  const { t } = useTranslation(['buttons']);
  const { iconOnly: miniDrawer } = useContext(SidebarPanelContext);

  return miniDrawer ? (
    <Tooltip title={t('auth.logout', { ns: 'buttons' })}>
      <IconButton
        aria-label="logout"
        color="menuItem"
        onClick={onClick}
        sx={{ alignSelf: 'center' }}>
        <Logout />
      </IconButton>
    </Tooltip>
  ) : (
    <StyledDrawerMenuLogoutContainer>
      <StyledLogoutButton
        color="menuItem"
        onClick={onClick}
        startIcon={<Logout sx={{ marginRight: '20px' }} />}>
        {t('auth.logout', { ns: 'buttons' })}
      </StyledLogoutButton>
    </StyledDrawerMenuLogoutContainer>
  );
}

DrawerLogoutButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default DrawerLogoutButton;
